import React, { Component } from 'react';
import axios from 'axios';
import { Link, Redirect } from 'react-router-dom';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import Icon from '../../partials/Icon';
import Student from './Student';
import Project from './Project';

export default class Group extends Component {
    state = {
        group: {
            name : '',
            school_id: ''
        },
        redirectBack: false,
        message: ''
    }

    constructor(props) {
        super(props);

        this.inputChange = this.inputChange.bind(this);
        this.saveGroup = this.saveGroup.bind(this);
        this.removeGroup = this.removeGroup.bind(this);
        this.fetch = this.fetch.bind(this);
    }

    componentDidMount() {
        this.fetch();
    }

    fetch() {
        axios.get(API_URL+'/admin/groups/'+this.props.match.params.id)
            .then(response => {
                this.setState({ group: response.data });
            });
    }

    inputChange(event) {
        this.setState({ group: {...this.state.group, [event.target.name]: event.target.value }});
    }

    saveGroup(event) {
        event.preventDefault();

        axios.put(API_URL+'/admin/groups/'+this.props.match.params.id, {
            name: this.state.group.name,
            school_id: this.state.group.school_id
        })
        .then(response => {
            this.setState({ message: 'Ändringarna har sparats.' });
        })
        .catch(error => {
            // Valideringsfel
            if (error.response && error.response.status === 422) {
                this.setState({ errors: error.response.data });
            }
            // Annat fel
            if (error.response && error.response.status === 400) {
                this.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    removeGroup(event) {
        event.preventDefault();
        var self = this;

        axios.delete(API_URL+'/admin/groups/'+this.props.match.params.id)
        .then(response => {
            this.setState({ redirectBack: true });
        })
        .catch(error => {
            // Annat fel
            if (error.response && error.response.status === 400) {
                self.setState({ errors: {1: 'Någonting gick fel, var god försök igen.'} })
            }
        });
    }

    render() {
        const { group } = this.state;
        const self = this;

        if (this.state.redirectBack) {
            return <Redirect to={ `/superadmin/schools/edit/${ this.state.group.school_id }` } message="Gruppen har tagits bort" />
        }

        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                    </div>
                </div>

                <Errors errors={ this.state.errors } />
                <Message message={ this.state.message } />

                <div className="container">
                    <div className="content">
                        <h1>Redigera grupp</h1>

                        <form onSubmit={ this.saveGroup }>
                            <label>Namn</label>
                            <input type="text" name="name" value={ this.state.group.name } onChange={ this.inputChange } />
                            <input className="button purple" type="submit" value="Spara" />
                        </form>

                        <div className="block">
                            <div className="header">
                                <h4>Projekt</h4>
                                <Link to={ `/superadmin/projects/add/${ group.id }` }>Lägg till</Link>
                            </div>
                            <div className="body">
                                { (group.projects && group.projects.length > 0) ? (
                                    <ul className="has-icons">
                                        { Object.keys(group.projects).map(function(key) {
                                            return (
                                                <Project key={ key } project={ group.projects[key] } group_id={ group.id } update={ self.fetch } />
                                            )
                                        })}
                                    </ul>
                                ) : (
                                    <span>Det finns inga projekt till denna grupp.</span>
                                ) }
                            </div>
                        </div>

                        <div className="block">
                            <div className="header">
                                <h4>Admins</h4>
                                <Link to={ `/superadmin/groups/admins/handle/${ group.id }` }>Hantera</Link>
                                <Link to={ `/superadmin/groups/admins/add/${ group.id }` }>Lägg till</Link>
                            </div>
                            <div className="body">
                                { (group.admins && group.admins.length > 0) ? (
                                    <ul className="has-icons">
                                        { Object.keys(group.admins).map(function(key) {
                                            return (
                                                <li key={ key }>
                                                    <Icon icon="user" color="pink" />
                                                    <Link key={ key } to={ `/superadmin/admins/edit/${ group.admins[key].id }` }>{ group.admins[key].first_name } { group.admins[key].last_name }</Link>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                ) : (
                                    <span>Det finns inga administratörer.</span>
                                ) }
                            </div>
                        </div>

                        <div className="block">
							<div className="block-top-link">
								<Link to={ `/superadmin/students/add/${ group.id }` }>
									<span>Lägg till deltagare</span>
									<span className="add-icon">+</span>
								</Link>
							</div>

							<div className="header">
                                <h4>Deltagare</h4>
								<span>Inloggningskoder</span>
                            </div>

                            <div className="body">
                                { (group.students && group.students.length > 0) ? (
                                    <ul className="has-icons">
                                        { Object.keys(group.students).map(function(key) {
                                            return (
                                                <Student key={ key } student={ group.students[key] } group_id={ group.id } update={ self.fetch } />
                                            )
                                        })}
                                    </ul>
                                ) : (
                                    <span>Det finns inga deltagare.</span>
                                ) }
                            </div>
                        </div>

                        <div className="danger-zone">
                            <h3>Ta bort grupp</h3>
                            <p>Obs! Detta går inte att ångra. Tänk på att även statistik försvinner. Detta bör under inga omständigheter göras om gruppen använts.</p>
                            <button onClick={ this.removeGroup }>Ta bort</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Group/index.js